import * as Factory from 'factory.ts'
import faker from 'faker'

import {
  type ListApprovalGroup,
  type ApprovalGroup,
  type ApprovalGroupApprover,
  type ApprovalGroupTrigger,
  type SimpleApprovalGroup,
} from '@webapp/models/ApprovalGroup'
import { SimpleUserMock } from './user.factory'

export const ApprovalGroupTriggerMock =
  Factory.Sync.makeFactory<ApprovalGroupTrigger>({
    content_type: Factory.each(() => faker.random.number()),
  })

export const ApprovalGroupApproverMock =
  Factory.Sync.makeFactory<ApprovalGroupApprover>({
    id: Factory.each(() => faker.random.number()),
    group: Factory.each(() => faker.random.number()),
    sequence: Factory.each((index) => index + 1),
    threshold: Factory.each(() => faker.commerce.price()),
    user: Factory.each(() => SimpleUserMock.build()),
    vacation_active: false,
    request_type: 'ORDER',
  })

export const ApprovalGroupMock = Factory.Sync.makeFactory<ApprovalGroup>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.random.word()),
  rank: Factory.each(() => faker.random.number()),
  approvers: Factory.each(() => ApprovalGroupApproverMock.buildList(2)),
  triggers: Factory.each(() => ApprovalGroupTriggerMock.buildList(2)),
  is_pooled: false,
})

export const SimpleApprovalGroupMock =
  Factory.Sync.makeFactory<SimpleApprovalGroup>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.random.words(4)),
  })

export const ListApprovalGroupMock =
  Factory.Sync.makeFactory<ListApprovalGroup>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.random.word()),
    rank: Factory.each(() => faker.random.number()),
    is_pooled: false,
  })
